import { createContext, type Dispatch, type SetStateAction, use } from 'react';

import { emptyFunction } from '@/utils/emptyFunction.util.ts';
import { type VacancyDetailsModel } from '@/views/vacancyDetails/model/VacancyDetails.model.ts';

export interface CopyObjectContextProps {
  setVacancyDetailsCopy: Dispatch<SetStateAction<VacancyDetailsModel | null>>;
  vacancyDetailsCopy: VacancyDetailsModel | null;
}

export const CopyObjectDefaultValues: CopyObjectContextProps = {
  setVacancyDetailsCopy: emptyFunction,
  vacancyDetailsCopy: null,
};
export const CopyObjectContext = createContext<CopyObjectContextProps>(CopyObjectDefaultValues);

export const useCopyObjectContext = (): CopyObjectContextProps => {
  return use<CopyObjectContextProps>(CopyObjectContext);
};
